import { DumGlobalEventDetailsDtoListGenericResponse } from '@src/Api/generated-global-event';
import {
  DUMCaseFileDto,
  DUMCaseFileDtoListGenericResponse
} from '@src/Api/generated-repository';
import {
  getMonth,
  getYear,
  month3char
} from '@src/Common/Constants/getFormatDate';

import {
  DumDTO,
  IDUMEventListMont,
  IDUMEventListYear,
  IDumSorted
} from './DUMEvents.type';

export const monthLists = month3char;

export const isValidCoordinate = (type: 'lat' | 'long', value = 0.0) => {
  //?NOTE: For function validation check lat and long
  if (type === 'lat') return value >= -90 && value <= 90;
  if (type === 'long') return value >= -180 && value <= 180;
  return false;
};

export const FilterDataTimeLine = (_data: IDumSorted[]) => {
  if (_data.length === 0)
    return {
      active: undefined,
      list: [],
      starYear: undefined,
      endYear: undefined
    };
  const starYear = _data[0].year;
  const endYear = _data[_data.length - 1].year;

  return {
    active: _data[0],
    list: _data,
    starYear: starYear,
    endYear: endYear
  };
};
interface DumValueExtended extends DumGlobalEventDetailsDtoListGenericResponse {
  value: any;
}
export const handleDataFormat = (
  _data: DUMCaseFileDtoListGenericResponse,
  _dataDUM: DumValueExtended
) => {
  //?NOTE: For function to combine data DUM and data casefile to same format

  const tempData = _dataDUM.value.data.data as Array<IDUMEventListYear>;
  _data.data?.forEach((result) => {
    //? TO SHOW YEAR AND MONTH
    const year = getYear(result.eventDate as string);
    const { monthNumber } = getMonth(result.eventDate as string);

    //? CHECK DATA DUM WITH YEAR
    const checkYear = tempData.filter((val) => val.year === Number(year));
    //? CHECK DATA DUM WITH MOUNTH WHEN HAVE YEAR
    const checkMount =
      checkYear.length > 0
        ? checkYear[0].data.filter((val) => val.month === monthNumber)
        : [];

    //? CONVERD DATA CASEFILE TO DUM
    const event = handleSetDataEvent(result) as unknown as DumDTO;

    if (checkYear.length === 0) {
      const updateData: IDUMEventListYear = {
        year: Number(year),
        data: [
          {
            month: monthNumber,
            events: [event]
          }
        ]
      };
      tempData.push(updateData);
    } else if (checkYear.length === 1 && checkMount.length === 0) {
      const newMount: IDUMEventListMont = {
        month: monthNumber,
        events: [event]
      };
      const sortMount = [...checkYear[0].data, newMount].sort(
        (a, b) => a.month - b.month
      );
      const updateData: IDUMEventListYear = {
        year: checkYear[0].year,
        data: sortMount
      };
      const lastData = tempData.filter((val) => val.year !== Number(year));

      lastData.push(updateData);
      tempData.splice(0, tempData.length, ...lastData);
    } else {
      const updateMount: IDUMEventListMont = {
        month: checkMount[0].month,
        events: [...checkMount[0].events, event]
      };
      const sortMount = [
        ...checkYear[0].data.filter((val) => val.month !== Number(monthNumber)),
        updateMount
      ].sort((a, b) => a.month - b.month);
      const updateData: IDUMEventListYear = {
        year: checkYear[0].year,
        data: sortMount
      };
      const lastData = tempData.filter((val) => val.year !== Number(year));

      lastData.push(updateData);
      tempData.splice(0, tempData.length, ...lastData);
    }
  });

  return {
    data: {
      data: tempData,
      meta: {
        total: _dataDUM.value.data.meta?.total + _data.data?.length
      }
    }
  };
};

export const handleSetDataEvent = (_list?: DUMCaseFileDto) => {
  //?NOTE: For function to set data casefile to format event data DUM
  return {
    author: _list?.authorNickname,
    authorImageUrl: _list?.authorImageUrl,
    country: _list?.locationName,
    description: _list?.description,
    eventDate: _list?.eventDate,
    eventMedia: _list ? _list.eventMedia : [],
    id: _list?.id,
    isCallistoDeployment: false,
    isDeltaContingencyEvent: false,
    isLimaContingencyEvent: false,
    isMythicEvent: false,
    isProtocolResponseEvent: false,
    isRiftwatchAlertEvent: false,
    latitude: _list?.latitude,
    locationName: _list?.locationName,
    longitude: _list?.longitude,
    name: _list?.title,
    reference: _list?.reference,
    scaleOfEvent: _list?.anomalyRating,
    status: 'Confirmed',
    totalDownvote: 0,
    totalUpvote: 0,
    type: 'casefile'
  };
};
